// Survey statuses
// Mirrors the statuses in the 'survey_status' table

export const AUTHORING = 0
export const FIELDING = 1
export const REFIELDING = 2
export const CLOSED = 3
export const SCHEDULED = 4
export const EDITING = 5
